import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full"
}
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "mb-6 text-center text-2xl font-semibold text-slate-950 sm:mb-10 sm:text-3xl" }, "Finalizar Pagamento Pix", -1)
const _hoisted_4 = { class: "w-full" }
const _hoisted_5 = { class: "flex w-full flex-col items-center justify-around gap-6 md:flex-row" }
const _hoisted_6 = { class: "my-2 flex w-full flex-col justify-center gap-4 sm:my-4 lg:gap-10" }
const _hoisted_7 = { class: "flex flex-col items-center justify-center" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "w-full max-w-60 text-center text-base font-semibold text-slate-700 sm:text-xl" }, " Tempo restante para efetuar o pagamento: ", -1)
const _hoisted_9 = {
  key: 0,
  class: "text-4xl font-bold text-slate-950 sm:text-6xl"
}
const _hoisted_10 = {
  key: 1,
  class: "text-4xl font-bold text-slate-950 sm:text-6xl"
}
const _hoisted_11 = { class: "flex w-full flex-col self-center rounded-2xl bg-slate-50 p-4 text-center sm:max-w-sm lg:self-start lg:text-left" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-semibold text-slate-950 sm:text-xl" }, "Detalhes do pedido:", -1)
const _hoisted_13 = { class: "text-base font-semibold text-slate-700 sm:text-lg" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "mt-2 text-xs text-slate-500 sm:text-sm" }, "Identificação do extrato:", -1)
const _hoisted_15 = { class: "break-all text-xs text-slate-600 sm:text-sm" }
const _hoisted_16 = { class: "flex w-full max-w-[18rem] justify-center self-center rounded-2xl p-4 shadow shadow-azul-claro sm:max-w-sm sm:p-10" }
const _hoisted_17 = { class: "mt-6 flex flex-col items-center gap-2 text-center text-xs font-semibold text-slate-500 sm:flex-row sm:text-left sm:text-base" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", {
  src: "img/LogoIcon.svg",
  class: "w-14 sm:w-20"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_qrcode_vue = _resolveComponent("qrcode-vue")!

  return (JSON.parse(JSON.stringify(_ctx.pix.id)) != '')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  (_ctx.pix.timer != -1)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(new Date(_ctx.pix.timer * 1000).toISOString().slice(11, 19)), 1))
                    : (_openBlock(), _createElementBlock("p", _hoisted_10, "00:00:00"))
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("div", null, [
                    _createElementVNode("p", _hoisted_13, " Valor: " + _toDisplayString(new Intl.NumberFormat("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                      minimumFractionDigits: 2,
                    }).format(JSON.parse(JSON.stringify(_ctx.pix.price)))), 1),
                    _hoisted_14,
                    _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.pix.id), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                (_ctx.blur === true)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "absolute z-30 h-24 w-24 self-center rounded-full bg-azul-claro p-5 text-white sm:h-32 sm:w-32 sm:p-6",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.regenerate && _ctx.regenerate(...args)))
                    }, [
                      _createVNode(_component_Icon, {
                        icon: "grommet-icons:power-reset",
                        class: _normalizeClass([_ctx.restartingQR ? 'animate-loading-spin' : '', "w-full h-full"])
                      }, null, 8, ["class"])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_qrcode_vue, {
                  class: _normalizeClass(_ctx.blur ? 'blur-sm' : 'blur-none'),
                  value: JSON.parse(JSON.stringify(_ctx.pix.qrCode)),
                  size: 250,
                  level: "H"
                }, null, 8, ["class", "value"])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("p", null, " Copyright " + _toDisplayString(new Date().getFullYear()) + " Enerzee - Um mundo de possibilidades - Todos Os Direitos Reservados. ", 1)
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}